import { render, staticRenderFns } from "./_base-footer.vue?vue&type=template&id=e463aa0a&scoped=true&"
import script from "./_base-footer.vue?vue&type=script&lang=js&"
export * from "./_base-footer.vue?vue&type=script&lang=js&"
import style0 from "./_base-footer.vue?vue&type=style&index=0&id=e463aa0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e463aa0a",
  null
  
)

export default component.exports